import RoleProtectedRoute from "@/modules/app/components/role-protected-route"
import { UserRole } from "@/shared/entities/users"
import { Navigate, Outlet, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "supervisor",
  element: (
    <RoleProtectedRoute redirect="/dashboard" rolesAllowed={[UserRole.SUPERVISOR]}>
      <Outlet />
    </RoleProtectedRoute>
  ),
  children: [
    {
      index: true,
      lazy: async () => {
        const { default: TrackingCoursesPage } = await import("@/pages/supervisor/tracking/courses")
        return {
          Component: TrackingCoursesPage,
        }
      },
    },
    {
      path: "students",
      lazy: async () => {
        const { default: TrackingStudentsPage } =
          await import("@/pages/supervisor/tracking/students")
        return {
          Component: TrackingStudentsPage,
        }
      },
      children: [
        {
          path: ":id",
          lazy: async () => {
            const { default: TrackingStudentIdPage } =
              await import("@/pages/supervisor/tracking/students/id")
            return {
              Component: TrackingStudentIdPage,
            }
          },
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/dashboard" replace />,
    },
  ],
}

export default routes
